import styled from "styled-components";

export const HeaderWrapper = styled.header`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding-top: 2rem;
    font-family: Arial,sans-serif;
`
export const Logo = styled.img`
    width: 5rem;
    height: 5rem;
`